var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOnboardBuild(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    rx: 3,
    fill: "#EFEFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.833 17.7499V28.2499C21.833 28.8916 21.308 29.4166 20.6664 29.4166H17.7497C15.9764 29.4166 14.378 28.6933 13.2114 27.5383C12.1147 26.4299 11.403 24.9249 11.333 23.2566C11.193 19.5933 14.3897 16.5833 18.0647 16.5833H20.6664C21.308 16.5833 21.833 17.1083 21.833 17.7499Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.6666 22.7433C34.8182 26.4183 31.6216 29.4166 27.9466 29.4166H25.3449C24.7032 29.4166 24.1782 28.8916 24.1782 28.2499V17.7499C24.1782 17.1083 24.7032 16.5833 25.3449 16.5833H28.2616C30.0349 16.5833 31.6332 17.3066 32.7999 18.4616C33.8849 19.5699 34.5966 21.0749 34.6666 22.7433Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6668 23.875H18.3335C17.8552 23.875 17.4585 23.4783 17.4585 23C17.4585 22.5217 17.8552 22.125 18.3335 22.125H27.6668C28.1452 22.125 28.5418 22.5217 28.5418 23C28.5418 23.4783 28.1452 23.875 27.6668 23.875Z",
    fill: "#999999"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardBuild);
export default __webpack_public_path__ + "static/media/onboard-build.4413931e04588c75d1f03def27c7d316.svg";
export { ForwardRef as ReactComponent };